import MonitorPage  from './pages/Monitor';

MonitorPage.path = '/monitor';

export default {
  pages: {
    MonitorPage,
  }
};
